import { cn } from '@/_shared/lib/utils';

/** The AND/OR combinator chip — **blue (brand) AND** · **green OR** (`success`). A static label in this slice
 *  (editing the operator is deferred — see the plan). Shown standalone between root cards and inline in a
 *  non-first sibling's lead-in slot. */
export function ConnectorPill({ op }: { op: 'and' | 'or' }) {
  const isAnd = op === 'and';
  return (
    <span
      className={cn(
        'inline-flex shrink-0 rounded-md px-1.5 py-0.5 text-xs font-medium tracking-wider uppercase',
        isAnd ? 'bg-highlight-bg text-brand' : 'bg-success-bg text-success',
      )}
    >
      {isAnd ? 'AND' : 'OR'}
    </span>
  );
}
